import { createElement } from "react";
import React from "react";
import * as react from "react";
import { reactApi } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ctx as ctx_1 } from "../Context.js";
import { createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import Cancel from "@mui/icons-material/Cancel";
import AccessTime from "@mui/icons-material/AccessTime";
import { Components_Chip_51BC9844, ComponentsModule_Chip_Level } from "../Components/Chip.js";
import { ServiceStatus__ToString_12C6553D } from "../Shared/Shared.js";

export function Activities_StatusChip_2E7B7895(activity) {
    const ctx = reactApi.useContext(ctx_1);
    let icon;
    const matchValue = activity.Status;
    switch (matchValue.tag) {
        case 2: {
            icon = ((props_3) => {
                const props_5 = createObj(props_3);
                return react.createElement(InfoOutlined, props_5);
            });
            break;
        }
        case 3: {
            icon = ((props_6) => {
                const props_8 = createObj(props_6);
                return react.createElement(Cancel, props_8);
            });
            break;
        }
        default:
            icon = ((props) => {
                const props_2 = createObj(props);
                return react.createElement(AccessTime, props_2);
            });
    }
    let color;
    const matchValue_1 = activity.Status;
    switch (matchValue_1.tag) {
        case 2: {
            color = (new ComponentsModule_Chip_Level(1, []));
            break;
        }
        case 3: {
            color = (new ComponentsModule_Chip_Level(2, []));
            break;
        }
        default:
            color = (new ComponentsModule_Chip_Level(0, []));
    }
    const $key2A744F87 = `activity-${activity.Id}-status`;
    return createElement(Components_Chip_51BC9844, {
        key: $key2A744F87,
        $key: $key2A744F87,
        primary: ServiceStatus__ToString_12C6553D(activity.Status, ctx.Language),
        enabled: true,
        startIcon: icon,
        colorLevel: color,
    });
}

